import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${APP_PREFIX_PATH}/dashboards`}
          component={lazy(() => import(`./dashboards`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/change-password`}
          component={lazy(() => import(`./change-password`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/report`}
          component={lazy(() => import(`./report`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/lessons`}
          component={lazy(() => import(`./lessons`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/challenge`}
          component={lazy(() => import(`./challenge`))}
        />

        <Redirect
          from={`${APP_PREFIX_PATH}`}
          to={`${APP_PREFIX_PATH}/dashboards`}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
